import { css } from '@linaria/core';
import theme from '@/components/core/theme';

export const container = css`
  --coll-size: var(--size, 48px);

  aspect-ratio: 1;
  min-width: var(--coll-size);
  min-height: var(--coll-size);
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: calc(var(--coll-size) * 0.05);
  padding: calc(var(--coll-size) * 0.05);
  grid-auto-flow: row;
  display: grid;
  box-shadow: ${theme.elevation.peoople};
  border: none;
  border-radius: calc(var(--coll-size) * 0.1);
  grid-template-areas:
    'col1 row1'
    'col1 row2';
`;

export const cell = css`
  background-size: cover;
  background-position: center;
  background-origin: content-box;
  border-radius: calc(var(--coll-size) * 0.1);
  background-color: var(--color, ${theme.colors.peoople['gris-medio-claro']});
  background-image: var(--image, ${theme.colors.peoople['gris-medio-claro']});
`;
export const col1 = css`
  grid-area: col1;
`;

export const row1 = css`
  grid-area: row1;
`;

export const row2 = css`
  grid-area: row2;
`;
